module.exports = __webpack_public_path__ + "static/media/LTC-USDC.5f9cebbd.svg";